import * as Yup from 'yup';

const confirmDownloadSurvey = Yup.object().shape({
  confirmDownload: Yup.boolean()
    .oneOf([true], 'You must agree to the terms and conditions')
    .required('You must agree to the terms and conditions')
});

export default confirmDownloadSurvey;
